export function getReadableTextColor(bgColor: string) {
  // Parse hex
  const hex = bgColor.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16) / 255
  const g = parseInt(hex.substring(2, 4), 16) / 255
  const b = parseInt(hex.substring(4, 6), 16) / 255

  // Apply gamma correction
  const [R, G, B] = [r, g, b].map((c) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)))

  // Calculate relative luminance
  const luminance = 0.2126 * R + 0.7152 * G + 0.0722 * B

  // If luminance is high, use dark text; otherwise use light text
  return luminance > 0.179 ? '#000000' : '#FFFFFF'
}

// Determine color based on string hash
export function hexColorForString(string = ''): string {
  let hash = 0
  if (string.length === 0) return '#888'
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
    hash = hash & hash
  }
  let color = '#'
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 255
    color += ('00' + value.toString(16)).slice(-2)
  }
  return color
}
